/**
 * @generated SignedSource<<0f181a738c1442c2ab87fd21c6e0feec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type usePartialItems_viewer$data = {
  readonly sbBatchLazyLoadFeatureFlag: boolean | null;
  readonly " $fragmentType": "usePartialItems_viewer";
};
export type usePartialItems_viewer$key = {
  readonly " $data"?: usePartialItems_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"usePartialItems_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "usePartialItems_viewer",
  "selections": [
    {
      "alias": "sbBatchLazyLoadFeatureFlag",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "sbBatchLazyLoad"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"sbBatchLazyLoad\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "9da000a480787b6f5257f84502848c17";

export default node;
